import React from "react";
import { Link } from "gatsby";
import Image from "@herb/components/Image";
import { track, trackTransferToShop, trackSelectItem } from "@herb/utils/analytics";
import { getOutboundLinkRel } from "@herb/utils";
import productLink from "@herb/utils/productLink";
import Button from "@herb/components/Button";
import "./index.css";
import { fallbackImages } from "../../../utils/constants";
const SidebarProductCard = ({ productdetails }) => {
  const { acf, contentProducts } = productdetails;

  const image = acf
    ? (acf || {}).product_images[0]
    : (contentProducts || {}).productImages[0];
  const sourceUrl = image?.sourceUrl || image?.source_url;
  const altText = (image || {}).altText || (image || {}).alt_text;
  const { productCategory: category, affiliateUrl } = contentProducts;
  const brandName =
    productdetails.acf?.brand?.post_title ||
    contentProducts?.brand?.title ||
    productdetails.brand_name ||
    "";

  const trackShopButtonEvent = to => () => {
    let analytics = { locationOnPage: "Product Page Affiliate CTA" };

    // New transfer_to_shop event
    trackTransferToShop({
      affiliateUrl: to,
      contentType: 'article',
      surfaceType: 'sidebar_product',
      productTitle: productdetails.title,
      category: category?.name || '',
      brand: brandName
    });

    // Legacy tracking
    if (typeof window !== undefined) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "Shop Button Clicked"
      });
    }

    track("Shop Button Click", {
      to,
      ...(analytics || {})
    });

    return true;
  };
  return (
    <div className="sidebarRandomProductCard">
      <div className="sidebarRandomProductCardInner">
        <Image
          className="lazyload sidebarRandomProductImage"
          fallback={fallbackImages.square}
          src={sourceUrl}
          alt={altText || productdetails.title}
          width={200}
        />
        <div className="sidebarRandomProductCategoryAndBrand">
          <p className="sidebarRandomProductCategory">
            {category.name}&nbsp;
            <span className="sidebarRandomProductBrand">
              by {productdetails.acf.brand.post_title}
            </span>
          </p>
        </div>
        <p className="sidebarRandomProductTitle">{productdetails.title}</p>
      </div>
      <div className="sidebarRandomProductCardFooter">
        <Button
          href={affiliateUrl}
          analytics={trackShopButtonEvent(affiliateUrl)}
          target="_blank"
          link
          rel={getOutboundLinkRel({ brand: brandName })}
          css={{
            fontStyle: "italic",
            fontWeight: "300",
            padding: "6px 18px",
            fontSize: "20px",
            lineHeight: "24px",

            display: "inline-block",
            background: "#3041FF",
            color: "white"
          }}
          type={"boutiqueButton"}
        >
          SHOP NOW
        </Button>
        <Link
          to={`${productLink(productdetails)}`}
          onClick={() => {
            trackSelectItem({
              itemName: productdetails.title,
              itemCategory: category?.name || '',
              surfaceType: 'sidebar_module',
              brand: brandName
            });
          }}
          css={{
            fontStyle: "italic",
            fontWeight: "400",
            fontSize: "13px",
            lineHeight: "24px",
            margin: "5px 0 0 0",
            display: "inline-block",
            textDecorationLine: "underline",
            textTransform: "uppercase",
            color: "#141313",
            fontFamily: "Source Code Pro"
          }}
        >
          View Product
        </Link>
      </div>
    </div>
  );
};

export default SidebarProductCard;
